export const getNormalizedSearch = (search?: string | null) => {
  const normalizedSearch = search?.trim();

  return normalizedSearch || undefined;
};
